import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row container-fluid mt-2 d-flex w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-8" }, null, -1)
const _hoisted_3 = { class: "col-xl-4 text-end" }
const _hoisted_4 = { class: "text-black" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-black me-3" }, " Total de la commande : ", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-black"
}
const _hoisted_7 = { class: "text-black me-3" }
const _hoisted_8 = {
  key: 1,
  class: "text-black"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-black me-3" }, " Cart de fidélité : ", -1)
const _hoisted_10 = {
  key: 2,
  class: "text-black"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-black me-3" }, " Total de Réduction : ", -1)
const _hoisted_12 = {
  key: 3,
  class: "text-black"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-black me-3" }, " Frais de livraison : ", -1)
const _hoisted_14 = {
  key: 4,
  class: "text-black"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-black me-3" }, " Montant HT : ", -1)
const _hoisted_16 = {
  key: 5,
  class: "text-black"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-black me-3" }, " Montant TTC : ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.order?.totalPriceOrder?.toFixed(2) ?? 0.00) + " €", 1)
        ])
      ]),
      (_ctx.order?.promocode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, " Code promo " + _toDisplayString(_ctx.order?.promocode?.code_number) + " : ", 1),
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.order?.promocode?.percentage) + " %", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order?.loyalty_card)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.order?.loyalty_card?.percentage) + " %", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order?.totalDiscount)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, "-" + _toDisplayString(_ctx.order?.totalDiscount.toFixed(2)) + " €", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order?.type == 'liv')
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.order?.fees?.toFixed(2) ?? 0.00) + " € ", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order?.total_amount)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString((_ctx.order?.total_amount / 1.1).toFixed(2)) + " €", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order?.total_amount)
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.order?.total_amount.toFixed(2)) + " €", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}